import { REDUX_BOOKING_SERVICES } from "../config"

const initialState = {
  allVehicles: [],
  allServiceCategory: [],
  allService: [],
  allAddOnService: [],
}

const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_BOOKING_SERVICES.GET_VEHICLES():
      return {
        ...state,
        allVehicles: action.payload,
      }
    case REDUX_BOOKING_SERVICES.GET_SERVICE_CATEGORY():
      return {
        ...state,
        allServiceCategory: action.payload,
      }

    case REDUX_BOOKING_SERVICES.GET_SERVICE():
      return {
        ...state,
        allService: action.payload,
      }
    case REDUX_BOOKING_SERVICES.GET_ADDON_SERVICE():
      return {
        ...state,
        allAddOnService: action.payload,
      }
    default:
      return state
  }
}

export default serviceReducer
